import { createFileRoute, Outlet, useLocation, useNavigate, useRouter } from '@tanstack/react-router';
import { Button } from 'antd';
import { ArrowLeft, LogOut } from 'lucide-react';

import { signOutWithRevoke } from '../../../modules/auth/sign-out';
import { BILLING_GATE_STRATEGY } from '../../../modules/billing';
import { CenteredLayout } from '../../../ui/components/layout';
import { hideHtmlLoader } from '../../../ui/utils/html';

const OnboardingLayout = () => {
  const router = useRouter();
  const navigate = useNavigate();
  const location = useLocation();
  const showBackButton =
    BILLING_GATE_STRATEGY === 'in_app' && location.pathname === '/onboarding/billing';

  return (
    <CenteredLayout
      top={
        <Button
          icon={showBackButton ? <ArrowLeft size="1em" /> : <LogOut size="1em" />}
          color="default"
          variant="text"
          onClick={() => {
            if (showBackButton) {
              if (window.history.length > 1) {
                window.history.back();
              } else {
                void navigate({ to: '/' });
              }
              return;
            }

            void signOutWithRevoke().then(() => router.invalidate());
          }}
          style={{ opacity: 0.5 }}
        >
          {showBackButton ? 'Back' : 'Log out'}
        </Button>
      }
    >
      <Outlet />
    </CenteredLayout>
  );
};

export const Route = createFileRoute('/_authenticated/onboarding')({
  beforeLoad: () => {
    hideHtmlLoader();
  },
  component: OnboardingLayout,
});
